import React from 'react';
import { LoadingSpinner, ErrorMessage, ChartInfoButton, ChartGuideModal } from '../components/ui';
import LicenseGate from '../components/ui/LicenseGate';
import DashboardSectionAnchor from '../components/ui/DashboardSectionAnchor';
import { useTimeFrame } from '../contexts/TimeFrameContext';
import useChartGuide from '../hooks/useChartGuide';
import { TimePeriod } from '../types/api';
import { logger } from '../utils/logger';
import {
  CustomerKPIsSection,
  TotalOrdersNonOrders,
  TotalCustomerOrders,
  NoOrdersLastTwoMonths,
  OrdersLastTwoMonths,
  CustomerReportSection,
  AveragePurchasesTable,
  AveragePurchasesYoYTable,
  PurchasePercentagesChart
} from '../components/customerAnalytics';
// import { CustomerRetentionAnalysis } from '../components/mainPerformance';
import { CustomerTrendsWithBalanceChart } from '../components/customerAnalytics';
import { getTimeRangeMonths } from '../utils';

interface CustomerAnalyticsDashboardProps {
  branchId?: number;
  customTimeRange?: TimePeriod;
}

const CustomerAnalyticsDashboard: React.FC<CustomerAnalyticsDashboardProps> = ({
  branchId = 0, // Default to دونرگاردن پاسداران
  customTimeRange
}) => {
  const { apiTimeFrame } = useTimeFrame();
  const { isModalOpen, currentGuide, openGuide, closeGuide } = useChartGuide();
  
  // Use customTimeRange if provided, otherwise use the one from context
  const effectiveTimeRange = customTimeRange || apiTimeFrame;
  
  // Convert time range to months
  const getMonthsFromTimeRange = (timeRange: string): number => {
    logger.debug(`Converting time range to months: ${timeRange}`, 'CustomerAnalyticsDashboard');
    switch (timeRange) {
      case '1month':
        return 1;
      case '3months':
        return 3;
      case '6months':
        return 6;
      case '12months':
      default:
        return 12;
    }
  };
  
  const months = getMonthsFromTimeRange(effectiveTimeRange);

  // Convert months to the timeRange format expected by CustomerRetentionAnalysis
  const retentionTimeRange = months === 1 ? 'last1Month' : months === 3 ? 'last3Months' : months === 12 ? 'lastYear' : 'last6Months';

  return (
    <LicenseGate licenseType="club" dashboardName="داشبورد تحلیل مشتریان">
      <div className="container-dashboard" dir="rtl">
        <div className="space-y-8 md:space-y-10 animate-enter-up">

          <h1 className="title-dashboard">
            تحلیل مشتریان
          </h1>
      
          {/* KPI Cards */}
          {/* <CustomerKPIsSection branchId={branchId} /> */}
      
          {/* Pie Charts Section */}
          {/* <h2 className="title-section">
            تحلیل وضعیت مشتریان
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            Pie Chart 1
            <TotalOrdersNonOrders branchId={branchId} />

            Pie Chart 2
            <TotalCustomerOrders branchId={branchId} />

            Pie Chart 3
            <NoOrdersLastTwoMonths branchId={branchId} />

            Pie Chart 4
            <OrdersLastTwoMonths branchId={branchId} />
          </div> */}
      
          {/* Bar Chart and Table */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-12   border-t border-gray-200 dark:border-gray-700">
            <DashboardSectionAnchor sectionId="average-purchases-table">
              <AveragePurchasesTable branchId={branchId} months={months} />
            </DashboardSectionAnchor>
            <DashboardSectionAnchor sectionId="average-purchases-yoy-table">
              <AveragePurchasesYoYTable branchId={branchId} months={months} />
            </DashboardSectionAnchor>
          </div>

          <div className="grid grid-cols-1  gap-8 mt-12   border-t border-gray-200 dark:border-gray-700">
            <DashboardSectionAnchor sectionId="customer-report-section">
              <CustomerReportSection branchId={branchId} months={months} />
            </DashboardSectionAnchor>
          </div>
      
          {/* Purchase Group Tables - Not implemented in components yet */}
          {/* Will need to add this functionality if needed */}

          {/* Trend Charts */}
          {/* <h2 className="title-section">
            تحلیل روند مشتریان
          </h2> */}
                
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 ">
            {/* Customer Retention Analysis */}
            {/* <CustomerRetentionAnalysis branchId={branchId} timeRange={retentionTimeRange} /> */}

            {/* Customer Trends with Balance */}
            <DashboardSectionAnchor sectionId="customer-trends-balance-chart" className="lg:col-span-2">
              <CustomerTrendsWithBalanceChart
                branchId={branchId}
                months={getTimeRangeMonths(retentionTimeRange)}
                title="تحلیل حفظ مشتریان"
                description="تحلیل نرخ بازگشت و وفاداری مشتریان"
              />
            </DashboardSectionAnchor>

            <DashboardSectionAnchor sectionId="purchase-percentages-chart">
              <PurchasePercentagesChart branchId={branchId} months={months} />
            </DashboardSectionAnchor>
          </div>
      
          {/* Chart Guide Modal */}
          <ChartGuideModal
            isOpen={isModalOpen}
            onClose={closeGuide}
            title="راهنمای نمودار"
          >
            <p>این داشبورد تحلیل جامعی از رفتار و وضعیت مشتریان ارائه می‌دهد.</p>
          </ChartGuideModal>
        </div>
      </div>
    </LicenseGate>
  );
};

export default CustomerAnalyticsDashboard;
